module.exports = __webpack_public_path__ + "static/img/logo.b6bf326f.png";